export enum DndBannerCardFieldType {
  Name = 'Name',
  Image = 'Image',
  Link = 'Link',
  IsValid = 'IsValid',
  AltText = 'AltText',
  HeaderText = 'HeaderText',
  ContentText = 'ContentText',
  SmallText = 'SmallText',
  ButtonText = 'ButtonText',
  FrAltText = 'FrAltText',
  FrHeaderText = 'FrHeaderText',
  FrContentText = 'FrContentText',
  FrSmallText = 'FrSmallText',
  FrButtonText = 'FrButtonText',
  FrImage = 'FrImage',
  TextColor = 'TextColor',
  ButtonTextColor = 'ButtonTextColor',
  TextAlignment = 'TextAlignment',
  ButtonAlignment = 'ButtonAlignment',
  SubmitFormCallback = 'SubmitFormCallback',
  Sources = 'Sources',
}
export enum TextAndButtonAlignment {
  TopLeft = '1',
  TopMiddle = '2',
  TopRight = '3',
  MiddleLeft = '4',
  MiddleMiddle = '5',
  MiddleRight = '6',
  BottomLeft = '7',
  BottomMiddle = '8',
  BottomRight = '9',
}
